import { PayloadAction } from '@reduxjs/toolkit';
import {
    call,
    put,
    select,
    takeLeading,
} from 'redux-saga/effects';

import { ApiError } from '../../utils/services';
import {
    cancelGenericBladeApi,
    fetchGenericBladeApi,
    submitGenericBladeApi,
} from './genericBladeApi';
import {
    selectGenericBladeCancelUrl,
    selectGenericBladeFetchUrl,
    selectGenericBladeSubmitUrl,
} from './genericBladeSelectors';

import {
    genericBladeCancel,
    genericBladeCancelFulfilled,
    genericBladeCancelRejected,
    genericBladeFetch,
    genericBladeFetchFulfilled,
    genericBladeFetchRejected,
    genericBladeSubmit,
    genericBladeSubmitFulfilled,
    genericBladeSubmitRejected,
} from './genericBladeSlice';
import { GenericBladeCancelPayload, GenericBladeSubmitPayload } from './genericBladeTypes';

function* genericBladeFetchWorkSaga(action: PayloadAction<string>) {
    const id = action.payload;

    try {
        const url: string = yield select((state) =>
            selectGenericBladeFetchUrl(state, id),
        );
        const { data } = yield call(fetchGenericBladeApi, url);

        yield put(genericBladeFetchFulfilled({ id, fetchPayload: data }));
    } catch (e) {
        const { message } = e as ApiError;

        yield put(genericBladeFetchRejected({ apiErrorMessage: message, id }));
    }
}

function* genericBladeFetchWatchSaga() {
    yield takeLeading(genericBladeFetch.type, genericBladeFetchWorkSaga);
}

function* genericBladeSubmitWorkSaga(
    action: PayloadAction<GenericBladeSubmitPayload>,
) {
    const { id, submittedPayload } = action.payload;

    const url: string = yield select((state) =>
        selectGenericBladeSubmitUrl(state, id),
    );

    if(url) {
        try {
            yield call(submitGenericBladeApi, url, submittedPayload);
            yield put(genericBladeSubmitFulfilled(action.payload));
        } catch (e) {
            const { message } = e as ApiError;

            yield put(genericBladeSubmitRejected({ apiErrorMessage: message, id }));
        }
    }
}

function* genericBladeSubmitWatchSaga() {
    yield takeLeading(genericBladeSubmit.type, genericBladeSubmitWorkSaga);
}

function* genericBladeCancelWorkSaga(
    action: PayloadAction<GenericBladeCancelPayload>,
) {
    const { id, cancelPayload } = action.payload;

    const url: string = yield select((state) =>
        selectGenericBladeCancelUrl(state, id),
    );

    if(url) {
        try {
            yield call(cancelGenericBladeApi, url, cancelPayload);
            yield put(genericBladeCancelFulfilled(action.payload));
        } catch (e) {
            const { message } = e as ApiError;

            yield put(genericBladeCancelRejected({ apiErrorMessage: message, id }));
        }
    }
}

function* genericBladeCancelWatchSaga() {
    yield takeLeading(genericBladeCancel.type, genericBladeCancelWorkSaga);
}

export const genericBladeSagas = [
    genericBladeFetchWatchSaga,
    genericBladeSubmitWatchSaga,
    genericBladeCancelWatchSaga,
];
